/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const GET_CURRENT_DISPLAY_OBJ_ADJUST = 'GET_CURRENT_DISPLAY_OBJ_ADJUST';
export const GET_CURRENT_DISPLAY_DETAIL_OBJ_ADJUST =
  'GET_CURRENT_DISPLAY_DETAIL_OBJ_ADJUST';
export const GET_PLAN_TYPE_DATA_ADJUST = 'GET_PLAN_TYPE_DATA_ADJUST';
export const GET_REBATE_PROGRAM_ADJUST = 'GET_REBATE_PROGRAM_ADJUST';
export const GET_ERROR_MSG_ADJUST = 'GET_ERROR_MSG_ADJUST';
export const GET_FROM_ADJUST = 'GET_FROM_ADJUST';
export const SELECT_OPTION = 'SELECT_OPTION';
export const SET_DISPLAY_OBJ_ADJUST = 'SET_DISPLAY_OBJ_ADJUST';
export const SET_REFRESH_DATA_ADJUSTMENT_CMS =
  'SET_REFRESH_DATA_ADJUSTMENT_CMS';
export const SET_REFRESH_DATA_ADJUSTMENT_CMS_DISPLAY =
  'SET_REFRESH_DATA_ADJUSTMENT_CMS_DISPLAY';
export const GET_REBATE_PROGRAM_NAME_ADJUST = 'GET_REBATE_PROGRAM_NAME_ADJUST';
export const GET_CMS_ADJUSTMENT_DATA = 'GET_CMS_ADJUSTMENT_DATA';
export const GET_CMS_REBATE_GROUP = 'GET_CMS_REBATE_GROUP';
export const GET_CMS_LIST_REBATE_GROUP = 'GET_CMS_LIST_REBATE_GROUP';
export const GET_CMS_REBATE_GROUP_NAME = 'GET_CMS_REBATE_GROUP_NAME';
export const GET_CMS_LIST_REBATE_GROUP_NAME = 'GET_CMS_LIST_REBATE_GROUP_NAME';
export const GROUP_BY_QTR_DATA = 'GROUP_BY_QTR_DATA';